
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.83 3.17a4 4 0 00-5.66 0l-4 4a4 4 0 005.66 5.66l4-4a4 4 0 000-5.66zM3.94 7.82L7.76 4A3.1 3.1 0 0112 3.77a3 3 0 01.12 4.35l-1.29 1.29a1 1 0 01-1.42 0l-1.7-1.7a1 1 0 00-1.42 0L5.06 8.94a.79.79 0 01-1.12 0 .79.79 0 010-1.12z"}})])
          )
        }
      }
    